import { atom } from 'jotai';

import type { GuidanceSession } from '../types/GuidanceSessions';

export const hasRecentlyBookedSessionAtom = atom<boolean>(false);

export const sessionForDetailsViewAtom = atom<GuidanceSession | null>(null);
